export default __webpack_public_path__ + "static/17-6047b641aaa5600f2f5d089caa28a9bd.jpg";